import { SET_BILLING_ADDRESS } from '../action-types';
import { CreateCustomerRoutine } from '~modules/Companies/redux-routines';

export const initialState = {
  data: {},
};

export const billingAddressRegistrationReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SET_BILLING_ADDRESS:
      return {
        ...state,
        data: {...state.data, ...action.payload}
      };
    case CreateCustomerRoutine.SUCCESS:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
